import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DevelopmentGuard } from './core/guards/development.guard';
import { OnboardingGuard } from './core/guards/onboarding.guard';
import { OrderGuard } from './core/guards/order.guard';
import { PaymentStateGuard } from './core/guards/payment-state.guard';
import { TransactionGuard } from './core/guards/transaction.guard';
import { ErrorGenericComponent } from './presentation/features/public/error-generic/error-generic.component';
import { ErrorPaymentComponent } from './presentation/features/public/error-payment/error-payment.component';
import { BaseComponent } from './presentation/mo-layout/base/base.component';
import { BiometricsGuard } from './core/guards/biometrics.guard';
import { PurchaselessOnboardingGuard } from './core/guards/purchaseless-onboarding.guard';
import { CompletedProfileGuard } from './core/guards/completed-profile.guard';
import { ValidationsGuard } from './core/guards/validations.guard';

const routes: Routes = [
  {
    path: '',
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./presentation/features/home/home.module').then((m) => m.HomeModule),
        canActivate: [TransactionGuard],
      },
    ],
  },
  {
    path: '',
    component: BaseComponent,
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'ingresar',
        loadChildren: () =>
          import('./presentation/features/auth/auth.module').then((m) => m.AuthModule),
        canActivate: [TransactionGuard],
      },
    ],
  },
  {
    path: '',
    component: BaseComponent,
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'verificacion-datos',
        loadChildren: () =>
          import('./presentation/features/onboarding/onboarding.module').then(
            (m) => m.OnboardingModule
          ),
        canActivate: [OnboardingGuard],
      },
    ],
  },
  {
    path: '',
    component: BaseComponent,
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'pagos',
        loadChildren: () =>
          import('./presentation/features/payments/payments.module').then((m) => m.PaymentsModule),
      },
    ],
  },
  {
    path: '',
    component: BaseComponent,
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'prestamo',
        loadChildren: () =>
          import('./presentation/features/customer/portal.module').then((m) => m.PortalModule),
      },
    ],
  },
  {
    path: 'error',
    component: BaseComponent,
    loadChildren: () =>
      import('./presentation/features/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'continua-tu-proceso',
    component: BaseComponent,
    loadChildren: () =>
      import('./presentation/features/public/continue-process/continue-process.module').then(
        (m) => m.ContinueProcessModule
      ),
  },
  {
    path: 'ui-kit',
    loadChildren: () =>
      import('./presentation/features/ui-kit/ui-kit.module').then((m) => m.UiKitModule),
    canActivate: [DevelopmentGuard],
  },
  {
    path: 'error-01',
    component: BaseComponent,
    children: [
      {
        path: '',
        component: ErrorGenericComponent,
      },
    ],
  },
  {
    path: 'error-payment-02',
    component: BaseComponent,
    children: [
      {
        path: '',
        component: ErrorPaymentComponent,
      },
    ],
  },
  {
    path: 'errors',
    component: BaseComponent,
    loadChildren: () =>
      import('./presentation/features/error/error.module').then((m) => m.ErrorModule),
  },
  {
    path: 'orden',
    component: BaseComponent,
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import('./presentation/features/order/order.module').then((m) => m.OrderModule),
    canActivate: [OrderGuard],
  },
  {
    path: 'estado-pago',
    component: BaseComponent,
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import('./presentation/features/payment-state/payment-state.module').then(
        (m) => m.PaymentStateModule
      ),
    canActivate: [PaymentStateGuard],
  },
  {
    path: 'biometria',
    component: BaseComponent,
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import('./presentation/features/biometrics/biometrics.module').then(
        (m) => m.BiometricsModule
      ),
    canActivate: [BiometricsGuard],
  },
  //PURCHASELESS ONBOARDING
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./presentation/features/home/home.module').then((m) => m.HomeModule),
    canActivate: [PurchaselessOnboardingGuard],
  },
  {
    path: 'perfil-completado',
    component: BaseComponent,
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import('./presentation/features/completed-profile/completed-profile.module').then(
        (m) => m.CompletedProfileModule
      ),
    canActivate: [CompletedProfileGuard],
  },
  {
    path: 'validaciones',
    component: BaseComponent,
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import('./presentation/features/validations/validations.module').then(
        (m) => m.ValidationsModule
      ),
    canActivate: [ValidationsGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
